module.exports = __webpack_public_path__ + "static/media/sockeye-salmon.41c1e4a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/sockeye-salmon.png
// module id = 335
// module chunks = 0